export default __webpack_public_path__ + "static/media/Pranay_Mehrotra.8f3efe70.png";